<template>
  <div class="d-flex justify-content-between">
    <driver-info
      class="quick-info__card"
    />
    <user-info class="quick-info__card" />
    <div
      class="d-flex flex-column justify-content-between quick-info__status"
    >
      <trip-number />
      <trip-status />
      <use-wallet
        v-if="tripDetails.state == 'COMPLETED' || tripDetails.state == 'ACCEPTED' || tripDetails.state == 'IN_PROGRESS' || tripDetails.state == 'ARRIVED' || tripDetails.state == 'CANCELED'"
      />
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import DriverInfo from './DriverInfo.vue'
import UserInfo from './UserInfo.vue'
import TripStatus from './TripStatus.vue'
import UseWallet from './UseWallet.vue'
import TripNumber from './TripNumber.vue'

export default {
  components: {
    DriverInfo,
    UserInfo,
    TripStatus,
    UseWallet,
    TripNumber,
  },
  setup(_, ctx) {
    const tripDetails = computed(() => ctx.root.$store.getters['trips/getTripDetails'])
    return {
      tripDetails,
    }
  },
}
</script>

<style scoped>
.quick-info__card {
  width: 34%;
}
.quick-info__status{
width: 30%;

}
</style>
